"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disconnect = exports.setAllowAutoDisconnect = exports.close = exports.open = exports.discoverDevices = exports.registerTransportModule = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const modules = [];
const registerTransportModule = (module) => {
    modules.push(module);
};
exports.registerTransportModule = registerTransportModule;
/**
 * @type discoverDevices
 * {@link discoverDevices}
 */
const discoverDevices = (accept = () => true) => {
    const all = [];
    for (let i = 0; i < modules.length; i++) {
        const m = modules[i];
        if (m.discovery && accept(m)) {
            all.push(m.discovery);
        }
    }
    return (0, rxjs_1.merge)(...all.map((o) => o.pipe((0, operators_1.catchError)((e) => {
        console.warn(`One Transport provider failed: ${e}`);
        return rxjs_1.EMPTY;
    }))));
};
exports.discoverDevices = discoverDevices;
const open = (deviceId) => {
    for (let i = 0; i < modules.length; i++) {
        const m = modules[i];
        const p = m.open(deviceId);
        if (p)
            return p;
    }
    return Promise.reject(new Error(`Can't find handler to open ${deviceId}`));
};
exports.open = open;
const close = (transport, deviceId) => {
    for (let i = 0; i < modules.length; i++) {
        const m = modules[i];
        const p = m.close && m.close(transport, deviceId);
        if (p)
            return p;
    }
    // fallback on an actual close
    return transport.close();
};
exports.close = close;
const setAllowAutoDisconnect = (transport, deviceId, allow) => {
    for (let i = 0; i < modules.length; i++) {
        const m = modules[i];
        const p = m.setAllowAutoDisconnect && m.setAllowAutoDisconnect(transport, deviceId, allow);
        if (p)
            return p;
    }
    return null;
};
exports.setAllowAutoDisconnect = setAllowAutoDisconnect;
const disconnect = (deviceId) => {
    for (let i = 0; i < modules.length; i++) {
        const dis = modules[i].disconnect;
        const p = dis(deviceId);
        if (p) {
            return p;
        }
    }
    return Promise.reject(new Error(`Can't find handler to disconnect ${deviceId}`));
};
exports.disconnect = disconnect;
//# sourceMappingURL=index.js.map